/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Photo_Frame_StyleInputs */

const en_photo_frame_style = /** @type {(inputs: Photo_Frame_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photo Frame Style`)
};

const es_photo_frame_style = /** @type {(inputs: Photo_Frame_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estilo de Marco de Foto`)
};

const fr_photo_frame_style = /** @type {(inputs: Photo_Frame_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style de Cadre Photo`)
};

const de_photo_frame_style = /** @type {(inputs: Photo_Frame_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotorahmen-Stil`)
};

const ja_photo_frame_style = /** @type {(inputs: Photo_Frame_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォトフレームのスタイル`)
};

const zh_photo_frame_style = /** @type {(inputs: Photo_Frame_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相框风格`)
};

const ar_photo_frame_style = /** @type {(inputs: Photo_Frame_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نمط إطار الصورة`)
};

const id_photo_frame_style = /** @type {(inputs: Photo_Frame_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gaya Bingkai Foto`)
};

const it_photo_frame_style = /** @type {(inputs: Photo_Frame_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stile Cornice Foto`)
};

const ru_photo_frame_style = /** @type {(inputs: Photo_Frame_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стиль Рамки для Фото`)
};

const pt_photo_frame_style = /** @type {(inputs: Photo_Frame_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estilo de Moldura de Foto`)
};

const ko_photo_frame_style = /** @type {(inputs: Photo_Frame_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사진 프레임 스타일`)
};

/**
* | output |
* | --- |
* | "Photo Frame Style" |
*
* @param {Photo_Frame_StyleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const photo_frame_style = /** @type {((inputs?: Photo_Frame_StyleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Photo_Frame_StyleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_photo_frame_style(inputs)
	if (locale === "es") return es_photo_frame_style(inputs)
	if (locale === "fr") return fr_photo_frame_style(inputs)
	if (locale === "de") return de_photo_frame_style(inputs)
	if (locale === "ja") return ja_photo_frame_style(inputs)
	if (locale === "zh") return zh_photo_frame_style(inputs)
	if (locale === "ar") return ar_photo_frame_style(inputs)
	if (locale === "id") return id_photo_frame_style(inputs)
	if (locale === "it") return it_photo_frame_style(inputs)
	if (locale === "ru") return ru_photo_frame_style(inputs)
	if (locale === "pt") return pt_photo_frame_style(inputs)
	return ko_photo_frame_style(inputs)
});